import { cn } from '@/lib/utils';

const TAMANHOS = {
  sm: 'size-10',
  md: 'size-16',
  lg: 'size-24',
} as const;

type PreloaderProps = {
  /** O que está sendo carregado — aparece sob a logo e é lido pelo leitor de tela. */
  mensagem?: string;
  tamanho?: keyof typeof TAMANHOS;
  className?: string;
  /**
   * Cobre a tela inteira — menu, barra e botões — enquanto os dados chegam:
   * com o banco longe, um clique no meio do carregamento levava a outra tela
   * ou disparava a ação duas vezes.
   */
  telaCheia?: boolean;
};

/**
 * Logo da Condusvale com um arco vermelho girando em volta: é o indicador de
 * carregamento das telas que esperam dados do servidor. O banco fica longe e
 * cada consulta demora — a marca pulsando mostra que o sistema está trabalhando.
 */
export default function Preloader({ mensagem, tamanho = 'md', className, telaCheia = false }: PreloaderProps) {
  const indicador = (
    <div
      role="status"
      aria-live="polite"
      className={cn('flex flex-col items-center justify-center gap-md', className)}
    >
      <div className={cn('relative shrink-0', TAMANHOS[tamanho])}>
        <span className="preloader-anel absolute -inset-[6px] rounded-full" aria-hidden="true" />
        <img src="/logo.png" alt="" className="preloader-logo size-full rounded-full" draggable={false} />
      </div>
      {mensagem ? (
        <p className="text-[14px] text-muted">{mensagem}</p>
      ) : (
        <span className="sr-only">Carregando…</span>
      )}
    </div>
  );

  if (!telaCheia) return indicador;

  return (
    <div
      aria-busy="true"
      className="fixed inset-0 z-50 flex items-center justify-center bg-dominant/85 px-md backdrop-blur-sm"
    >
      {indicador}
    </div>
  );
}
